import { apiService } from "@/core/services";

export const AUTH = {
  getLogin,
  getToken,
  getPermission,
};

const URL = {
  OAUTH2: "oauth2",
  LOGIN: "login",
  IDPSSOINIT: "idpssoinit",
  ME: "me",
};

function getLogin() {
  let requestOptions = {
    params: {},
  };

  return apiService().get(`/${URL.OAUTH2}/${URL.LOGIN}`, requestOptions);
}
function getToken(data) {
  let requestBody = {
    params: {
      code: data.code,
    },
  };

  return apiService().get(`/${URL.OAUTH2}/${URL.IDPSSOINIT}`, requestBody);
}
function getPermission() {
  let requestBody = {
    params: {},
  };

  return apiService().get(`/${URL.OAUTH2}/${URL.ME}`, requestBody);
}
